export enum UserStatus {
  Approved = 'approved',
  Rejected = 'rejected',
  Locked = 'locked',
  Closed = 'closed',
  EmailConfirmed = 'email_confirmed',
  Onboarding = 'onboarding',
  VerificationBlocked = 'id_verification_blocked',
}
